import PropTypes from "prop-types";
import classnames from "classnames";

import Button, { buttonVariants } from "../Button";
import { iconSizes } from "../Icon/index";

import "./navigationButton.scss";

const NavigationButton = ({
  label,
  ariaLabel,
  altLabel,
  variant,
  squared,
  collapsible,
  alignItems,
  href,
  iconName,
  iconPosition,
  iconSize,
  currentPage,
  disabled,
  className,
  ...restProps
}) => {
  const classNamePrefix = "nav-button";
  const classNames = classnames(
    classNamePrefix,
    `${classNamePrefix}--align-${alignItems}`,
    {
      [`${classNamePrefix}--collapsible`]: collapsible,
      [`${classNamePrefix}--current-page`]: currentPage,
      [`${classNamePrefix}--disabled`]: disabled,
    },
    className
  );

  return (
    <div className={classNames}>
      <Button
        variant={variant}
        collapsible={collapsible}
        squared={squared}
        href={(!currentPage && !disabled && href) || undefined}
        size="small"
        iconName={iconName}
        iconPosition={iconPosition}
        iconSize={iconSize}
        aria-label={ariaLabel || label}
        disabled={disabled || currentPage}
        {...restProps}
      >
        {label && <span className={`${classNamePrefix}__label`}>{label}</span>}
      </Button>
      {altLabel && collapsible && (
        <span className={`${classNamePrefix}__label-alt`}>{altLabel}</span>
      )}
    </div>
  );
};

export const navigationButtonVariants = buttonVariants;
export const navigationButtonAlignItems = ["start", "center", "stretch"];

NavigationButton.propTypes = {
  label: PropTypes.string,
  ariaLabel: PropTypes.string,
  altLabel: PropTypes.string,
  variant: PropTypes.oneOf(navigationButtonVariants),
  squared: PropTypes.bool,
  collapsible: PropTypes.bool,
  alignItems: PropTypes.oneOf(navigationButtonAlignItems),
  href: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconName: PropTypes.string,
  iconPosition: PropTypes.string,
  iconSize: PropTypes.oneOf(iconSizes),
  currentPage: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
};

NavigationButton.defaultProps = {
  label: undefined,
  ariaLabel: undefined,
  altLabel: undefined,
  variant: "outline",
  squared: false,
  collapsible: false,
  alignItems: "start",
  href: undefined,
  iconName: undefined,
  iconPosition: "left",
  iconSize: "medium",
  currentPage: false,
  disabled: false,
  className: undefined,
};

export default NavigationButton;
